module.exports = __webpack_public_path__ + "images/officialAccounts.efa89f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/officialAccounts.png
// module id = hKpj
// module chunks = 19